import { useEffect, useState, useMemo } from 'react';
import { useAuth, useEnv } from 'src/hooks';
import getURLparams from 'src/helpers/getURLparams';
import { useLocation } from 'react-router';
import createRouter from './createRouter';

function useRouteTo2() {
  const { EGOV, RADZTECH } = useEnv();
  const { portal, app, registry, require_change_pw } = useAuth();
  const { ixJCd, ixJob } = getURLparams(useLocation().search);

  const [routes, setRoutes] = useState([]);
  const [routeType, setRouteType] = useState('Guest');

  useEffect(() => {
    let canceled = false;

    const loadRoutes = async () => {
      let loadedRoutes = [];
      let type = 'Guest';

      if (!registry && !portal && !app) {
        type = 'Guest';
        loadedRoutes = EGOV
          ? (await import('./ibfrsGuestRoutes')).default
          : RADZTECH
          ? (await import('./radztechGuestRoutes')).default
          : (await import('./ulapBizGuestRoutes')).default;
      } else if (registry && !require_change_pw) {
        type = 'Registry';
        loadedRoutes = (await import('./registryRoutes')).default;
      } else if (registry && require_change_pw) {
        type = 'Registry';
        loadedRoutes = (await import('./changePwRoutes')).then(m => m.registry);
      } else {
        type = 'App';
        loadedRoutes = [
          ...(EGOV
            ? (await import('./ibfrsRoutes')).default
            : (await import('./ulapBizRoutes')).default)
        ];

        if (portal?.token) {
          const portalR = await import('./portalRoutes');
          loadedRoutes.push(...portalR.default(ixJCd, ixJob));
        } else {
          const portalLoginR = await import('./portalLoginRoutes');
          loadedRoutes.push(...portalLoginR.default);
        }

        if (app && !require_change_pw) {
          const aR = await import('./appRoutes');
          loadedRoutes.push(...aR.default);
        } else if (app && require_change_pw) {
          const cpR = await import('./changePwRoutes').then(m => m.app);
          loadedRoutes.push(...cpR);
        } else {
          const aLogin = await import('./appLoginRoutes');
          loadedRoutes.push(...aLogin.default);
        }
      }

      if (!canceled) {
        setRoutes(loadedRoutes);
        setRouteType(type);
      }
    };

    loadRoutes();

    return () => {
      canceled = true;
    };
  }, [portal, app, registry, EGOV, RADZTECH, require_change_pw, ixJCd, ixJob]);

  const router = useMemo(() => {
    if (!routes.length) return null;
    return createRouter(routes, { portal, app, registry });
  }, [routes, portal, app, registry]);

  return { routeType, router };
}

export default useRouteTo2;
